import { COMPANY } from "../data/company";

export const LogoMark = ({ className = "h-10 w-10", mono = false }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    {!mono && (
      <defs>
        <linearGradient id="bikGrad" x1="0" y1="64" x2="64" y2="0" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#10B981" />
          <stop offset="1" stopColor="#38BDF8" />
        </linearGradient>
      </defs>
    )}
    <rect
      x="3"
      y="3"
      width="58"
      height="58"
      rx="14"
      stroke={mono ? "currentColor" : "url(#bikGrad)"}
      strokeWidth="3"
      fill="rgba(11,19,43,0.6)"
    />
    <path d="M21 49 L28 16" stroke={mono ? "currentColor" : "url(#bikGrad)"} strokeWidth="4.5" strokeLinecap="round" />
    <path d="M43 49 L36 16" stroke={mono ? "currentColor" : "url(#bikGrad)"} strokeWidth="4.5" strokeLinecap="round" />
    <path d="M25 33h14M23.5 40h17" stroke={mono ? "currentColor" : "#38BDF8"} strokeWidth="3" strokeLinecap="round" opacity="0.9" />
    <circle cx="32" cy="13" r="3.6" fill={mono ? "currentColor" : "#10B981"} />
  </svg>
);

// Renders the built-in original mark, or COMPANY.logo.src once a logo file is uploaded.
export default function Logo({ mono = false, className = "" }) {
  if (COMPANY.logo.src) {
    return (
      <img
        src={COMPANY.logo.src}
        alt={COMPANY.logo.alt}
        className={`h-14 w-auto sm:h-16 ${className}`}
        data-testid="logo-img"
      />
    );
  }
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <LogoMark mono={mono} />
      {!mono && (
        <span className="leading-none">
          <span className="block font-display text-[19px] font-bold tracking-wide text-ink sm:text-xl">
            BIK COMMOTRADE
          </span>
          <span className="mt-1 block whitespace-nowrap font-mono text-[8px] uppercase tracking-[0.2em] text-brand-emeraldDark">
            Where Power Meets Precision
          </span>
        </span>
      )}
    </span>
  );
}
